module.exports = __webpack_public_path__ + "img/team-1-1.15596501.jpg";